// ============================================================================
// Overall Control — display settings.
//
// SLA, at-risk and breach rules are NOT here: the backend computes every status, once the user
// supplies the per-stage rules (Q3/Q4, SLA step).
// ============================================================================

// Weight shows in tonnes from this many kg up.
export const TONNES_FROM_KG = 1000;

// The live indicator refreshes data this often.
export const REFRESH_INTERVAL_MS = 60000;

// City / Type / Carrier changes wait this long for the next pick before the tabs refetch.
export const FILTER_DEBOUNCE_MS = 400;
